// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KcGPYJAHQY6Xe1DP2B4O{bottom:-4px;width:104px}`, "",{"version":3,"sources":["webpack://./src/widgets/Flow/ui/FlowActionNode/Actions/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,WAAA,CACA,WAAA","sourcesContent":[".dropdown {\n  bottom: -4px;\n  width: 104px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `KcGPYJAHQY6Xe1DP2B4O`
};
export default ___CSS_LOADER_EXPORT___;
